import React from 'react';
import PropTypes from 'prop-types';
import CheckboxGroup from 'components/checkbox_group';
import SurveyQuestionShape from '../constants/SurveyQuestionShape';

import dictToOptions from '../utils';

const MultipleSelectSurveyQuestion = props => {
  const { question, questionKey, onSelect } = props;

  const onChange = (name, selectedValues) => {
    onSelect(name, selectedValues);
  };

  return (
    <div className="survey-question">
      <div className="padding-bottom-10px">
        <h4>{question.text}</h4>
      </div>
      {question.sub_text && <p className="padding-bottom-10px">{question.sub_text}</p>}
      <CheckboxGroup
        name={questionKey}
        options={dictToOptions(question.answers)}
        formGroupLabel=""
        radioGroupClassName="square-checkbox-container"
        onChange={onChange}
      />
    </div>
  );
};

MultipleSelectSurveyQuestion.propTypes = {
  questionKey: PropTypes.string.isRequired,
  question: SurveyQuestionShape.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default MultipleSelectSurveyQuestion;
